module.exports = __webpack_public_path__ + "static/media/back.16da56e6.svg";